export const getError = (isPropertyTouched: boolean, error?: string) => {
  if (isPropertyTouched && error) {
    return error;
  }
  return '';
};
